import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { checkForNewBuild, reloadIfNewBuild, startBuildUpdateChecks } from '../utils/buildUpdate';

/**
 * REG-963: after an in-app navigation, a tab running an older build than the
 * one deployed reloads onto the destination (see utils/buildUpdate.ts).
 * Renders nothing.
 */
export function BuildUpdateWatcher(): null {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    startBuildUpdateChecks();
  }, []);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (reloadIfNewBuild()) return;
    // Learn about a deploy now, so the next navigation can move onto it.
    void checkForNewBuild();
  }, [location.pathname]);

  return null;
}

export default BuildUpdateWatcher;
